import * as types from '../mutations-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  workbenchSetting: {}
}

// actions
const actions = {}

// mutations
const mutations = {
  [types.SET_WORKBENCH_SETTING](state, data) {
    state.workbenchSetting = data
  },
  [types.SET_WORKBENCH_LAYOUT](state, data) {
    state.workbenchSetting.layout = JSON.parse(JSON.stringify(data))
  }
}
// getters
const getters = {
  getWorkbenchSetting: state => index => {
    return state.workbenchSetting
  },
  getWorkbenchLayout: state => () => {
    // 获取使用的布局
    return state.workbenchSetting.layout.slice(0, state.workbenchSetting.layout.length)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
